import React from 'react'; 

export const NotFound = () => {
    return(
        <div className="container component-container">
            <h2>Not Found</h2>
            <p>Sorry! We couldn't find the page you're looking for.</p>
        </div>
    )
}